import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { AnchorButtonComponent, ButtonComponent } from '@sb/ui/button';
import { SbDialogSharedModule } from '@sb/ui/dialog';
import { RiveAnimationDirective } from '@sb/ui/rive-animation';

import {
  FooterAction,
  OnboardingDialogData,
  OnboardingDialogResult,
  OnboardingDialogStep,
} from './onboarding-dialog.model';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'onboarding-dialog',
  imports: [
    NgStyle,
    SbDialogSharedModule,
    ButtonComponent,
    AnchorButtonComponent,
    TranslatePipe,
    RiveAnimationDirective,
  ],
  templateUrl: './onboarding-dialog.component.html',
})
export class OnboardingDialogComponent implements OnInit {
  dialogRef = inject<DialogRef<OnboardingDialogResult>>(DialogRef);
  data = inject<OnboardingDialogData>(DIALOG_DATA);
  private translate = inject(TranslateService);

  title: string;
  assetPath: string;
  isAnimation = false;
  primary: string;
  secondary: FooterAction;
  OnboardingDialogStep = OnboardingDialogStep;

  ngOnInit(): void {
    switch (this.data.step) {
      case OnboardingDialogStep.FINISH_INVITED:
        this.title = this.translate.instant("Invites sent! What's next?");
        this.assetPath = '/assets/animations/check-mark.riv';
        this.isAnimation = true;
        this.primary = this.translate.instant('Continue exploring');
        this.secondary = {
          type: 'text',
          text: this.translate.instant('Quick Start Guide'),
        };
        break;
      case OnboardingDialogStep.FINISH_INVITES_SKIPPED:
        this.title = this.translate.instant("You're all set! Time to explore Shiftbase.");
        this.assetPath = '/assets/animations/check-mark.riv';
        this.isAnimation = true;
        this.primary = this.translate.instant('Continue exploring');
        this.secondary = {
          type: 'text',
          text: this.translate.instant('Quick Start Guide'),
        };
        break;
    }
  }

  onPrimaryClick() {
    this.dialogRef.close({ action: 'primary' });
  }

  onSecondaryClick() {
    this.dialogRef.close({ action: 'secondary' });
  }
}
